/**
 * The settings section's own navigation.
 *
 * `settings-members.html` and its four siblings replace the main sidebar with
 * this one: a "← Back to Leadgible" link, a SETTINGS eyebrow, and six
 * destinations. It is drawn identically on all five Epic 4 screens, so it is
 * built once here rather than five times.
 *
 * THE PATHS ARE THE ONES DECISION-018 ALREADY FIXED where they exist. `/team`
 * is the Members page and `/settings` is the profile page — both are nav items
 * in `nav.ts` and changing either would be re-deciding DECISION-018 for the
 * sake of a URL. The three that have no main-nav entry get a `/settings/` path,
 * which is where they belong and where 4.2, 4.5 and 11.x will find them.
 *
 * Story 4.1.
 */
export type SettingsNavItem = {
  readonly label: string
  readonly path: string
  /** The story that replaces the placeholder behind it. */
  readonly story: string
}

export const SETTINGS_NAV: readonly SettingsNavItem[] = [
  { label: 'Profile', path: '/settings', story: '4.3' },
  { label: 'Members and roles', path: '/team', story: '4.1' },
  { label: 'Workspaces', path: '/settings/workspaces', story: '4.2' },
  { label: 'Billing and plan', path: '/billing', story: '10.7' },
  { label: 'Providers and credentials', path: '/settings/credentials', story: '11.2' },
  // Story 26.6 — between credentials and the audit log, as `settings-compliance.html` draws
  // the seven. Listed for everybody the settings frame is: the API serves the page to Owner
  // and Admin (PRD §7.6), and the page says so to anyone else, as Billing does.
  { label: 'Compliance', path: '/settings/compliance', story: '26.6' },
  { label: 'Audit log', path: '/settings/audit', story: '4.5' },
]

export const SETTINGS_PATHS: readonly string[] = SETTINGS_NAV.map((item) => item.path)

/**
 * Where an upgrade goes, by name rather than by string.
 *
 * `routes.tsx` and this list agreed on `/billing`; the over-cap row in the leads
 * list did not, and sent RULE-061's "Upgrade to see details" — the button that
 * IS the proof of a marketed Tier 1 claim — to `/settings/billing`, which no
 * route serves. A second caller writing the path out again is how that happened,
 * so there is one export now and nowhere left to write it.
 *
 * fixes: the over-cap upgrade button 404'd, found while building 10.1 (2026-08-27)
 */
export const BILLING_PATH = SETTINGS_NAV.find((item) => item.label === 'Billing and plan')!.path

/** Where "← Back to Leadgible" goes. The same landing page the shell uses. */
export const BACK_PATH = '/dashboard'
